import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'

const store = 'historyBrakeMeasurements'

const options = {
  headers: {
    Authorization: `${localStorage.getItem('TOKEN_MEASUREMENT')}`
  }
};

const apiBrakeURL = process.env.VUE_APP_API_BRAKE

export default {
  state: () => ({
    history: [],
    isLoad: false
  }),
  actions: {
    async getHistoryBrakeMeasurements (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const response =
        await api.get(`${apiBrakeURL}/dashboard/declaration?page=${filter.page}&limit=${filter.limit}`, options)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'history', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
    },
    async getHistoryBrakeMeasurement (context, id) {
      const response = await api.get(`${apiBrakeURL}/dashboard/declaration/${id}`, options)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'currentHistoryBrakeMeasurement', data: response.data })
      }
      return response.data
    }
  }
}
